import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Card, CardContent, Grid, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const CardStyled = styled(Card)(() => ({
  width: '100%',
  color: 'white',
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const CardContentStyled = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingLeft: '1.5rem',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    alignItems: 'start',
  },
}));

export const GridSectionStyled = styled(Grid)(() => ({
  width: '100%',
}));

export const GridStyled = styled(Grid)(() => ({
  width: '100%',
  flexGrow: 1,
}));

export const CardContentMain = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  justifyContent: 'space-between',
  width: '-webkit-fill-available',
  padding: 0,
}));

export const AlignButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  justifyContent: 'center',

  [theme.breakpoints.up('sm')]: {
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 2rem',
    flexDirection: 'row',
  },
}));

export const DownIcon = styled(KeyboardArrowDownIcon)(() => ({
  width: '2.5rem',
  height: '2.5rem',
  border: '1px solid white',
  borderRadius: '0.5rem',
  color: 'white',
}));

export const UpIcon = styled(KeyboardArrowUpIcon)(() => ({
  width: '2.5rem',
  height: '2.5rem',
  border: '1px solid white',
  borderRadius: '0.5rem',
  color: 'white',
}));

export const DatePickerContainer = styled('div')(() => ({
  display: ' flex',
  flexDirection: 'column',
  gap: '0.5rem',
}));
